import { BASE_PERMISSIONS, BASE_ROLES, TabWithPermissionsInterface } from 'base';

export const USER_MENU: TabWithPermissionsInterface[] = [
  {
    title: 'administration.manageLocation',
    url: '/administration/location-management',
    permissionsAllowed: [],
    rolesAllowed: [BASE_ROLES.CUSTOMER_ADMIN, BASE_ROLES.CUSTOMER_LOCATION_ADMIN],
    id: 10,
  },
  {
    title: 'user.management',
    url: '/administration/user-management',
    permissionsAllowed: [],
    rolesAllowed: [BASE_ROLES.CUSTOMER_ADMIN],
    id: 20,
  },
  {
    title: 'companyMasterData',
    url: '/administration/company-master-data',
    permissionsAllowed: [],
    rolesAllowed: [BASE_ROLES.CUSTOMER_ADMIN],
    id: 40,
  },
  {
    title: 'administration.userSettings',
    url: '/administration/user-settings',
    permissionsAllowed: [],
    rolesAllowed: [
      BASE_ROLES.CUSTOMER_ADMIN,
      BASE_ROLES.CUSTOMER_LOCATION_ADMIN,
      BASE_ROLES.CUSTOMER_USER,
      BASE_ROLES.CUSTOMER_WORK_COUNCIL,
    ],
    id: 50,
  },
];
